module.exports = __webpack_public_path__ + "img/IMG_7034.bd5ea13e.webp";